export default "./images/survio--_ZAr-assets-Hey.png";